import { getTAttributeObjRelListCrm3 } from '@/api/newCrm'
export function getBtn (btnIdArr, url) {
  let flagArr = []
  let isCutCrm3 = localStorage.getItem('isCutCrm3')
  if (isCutCrm3 != 1) {
    if (localStorage.getItem(url) != 'undefined') {
      let getSession = JSON.parse(localStorage.getItem(url)) // 后台
      for (let i = 0; i < btnIdArr.length; i++) {
        let flag = false
        if (getSession != undefined) {
          for (let a = 0; a < getSession.length; a++) {
            if (btnIdArr[i] == getSession[a]) {
              flag = true
              break
            }
          }
        }
        flagArr.push(flag)
      }
    }
    return flagArr
  } else {
    let id = getQueryVariable('menuOrBtnId')
    let MorBlist = null
    if (id) { // 地址后面有id得时候取id，没有得时候用url
      MorBlist = getChidlren(id)
    } else {
      // MorBlist = getChidlren(null, window.location.href.substring(window.location.href.indexOf('#') + 1))
      MorBlist = getChidlren(null, url)
    }
    btnIdArr.forEach((item, index) => {
      let id = ''
      if (MorBlist) {
        let flag = MorBlist.some(e => {
          if (e.code == item) {
            id = e.id
          }
          return e.code == item
        })
        if (flag) {
          flagArr.push(id)
        } else {
          flagArr.push(false)
        }
      }
    })
    return flagArr
  }
}
function getChidlren (id, url) {
  var hasFound = false // 表示是否有找到id值
  var result = null
  let data = JSON.parse(localStorage.getItem('menuList'))
  var fn = function (data) {
    if (Array.isArray(data) && !hasFound) { // 判断是否是数组并且没有的情况下，
      data.forEach(item => {
        if (id) {
          if (item.id == id) { // 数据循环每个子项，并且判断子项下边是否有id值
            result = item.buttonDetails// 返回的结果等于每一项
            hasFound = true // 并且找到id值
          } else if (item.childMenu || item.buttonDetails) {
            if (item.buttonDetails) {
              fn(item.buttonDetails) // 递归调用下边的子项
            } else {
              fn(item.childMenu) // 递归调用下边的子项
            }
          }
        } else {
          if (item.accessUrl == url) { // 数据循环每个子项，并且判断子项下边是否有id值
            result = item.buttonDetails// 返回的结果等于每一项
            hasFound = true // 并且找到id值
          } else if (item.childMenu || item.buttonDetails) {
            if (item.buttonDetails) {
              fn(item.buttonDetails) // 递归调用下边的子项
            } else {
              fn(item.childMenu) // 递归调用下边的子项
            }
          }
        }
      })
    }
  }
  fn(data) // 调用一下
  return result
}
function getQueryVariable (variable) {
  var src = window.location.href
  let query = src.substring(src.lastIndexOf('?') + 1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) { return pair[1] }
  }
  return (false)
}
export async function getAttributeA (attrCodes, tenantCode) { // 主要获取仓库的属性crm3使用
  let flagArr = []
  let attrCodeArr = attrCodes.split(',')
  let json = {}
  await getTAttributeObjRelListCrm3({
    targetType: 2, // '目标对象类型(1.用户，2.租户，3.客户)',
    tenantCode: tenantCode,
    useTenantCode: tenantCode,
    targetCode: tenantCode,
    attributeFlags: attrCodes
  }).then(res => {
    if (res) {
      let arr = JSON.parse(res)
      arr.forEach(item => {
        if (item) {
          json[item.attributeFlag] = item
        }
      })
      attrCodeArr.forEach(item => {
        if (json[item]) {
          if (json[item].attributeType != 2) { // 1、文本型、2逻辑判断
            flagArr.push(json[item].attributeValue)
          } else {
            if (json[item].attributeValue == 0) { // 0是，1否
              flagArr.push(true)
            } else {
              flagArr.push(false)
            }
          }
        } else {
          flagArr.push(false)
        }
      })
    }
  })
  return flagArr
}
export function getAttribute (attrCodes, targetType) {
  let flagArr = []
  let attrCodeArr = attrCodes.split(',')
  let json = {}
  if (localStorage.getItem('isCutCrm3') == 1) {
    getTAttributeObjRelListCrm3({
      targetType: targetType || 2, // '目标对象类型(1.用户，2.租户，3.客户)',
      tenantCode: localStorage.getItem('createTenantCode'),
      useTenantCode: localStorage.getItem('tenantCode'),
      targetCode: targetType == 1 ? localStorage.getItem('userCode') : localStorage.getItem('tenantCode'),
      attributeFlags: attrCodes
    }).then(res => {
      if (res) {
        let arr = JSON.parse(res)
        arr.forEach(item => {
          if (item) {
            json[item.attributeFlag] = item
          }
        })

        attrCodeArr.forEach(item => {
          if (json[item]) {
            if (json[item].attributeType == 1) { // 1、文本型、2逻辑判断
              flagArr.push(json[item].attributeValue)
            } else {
              if (json[item].attributeValue == 0) { // 0是，1否
                flagArr.push(true)
              } else {
                flagArr.push(false)
              }
            }
          } else {
            flagArr.push(false)
          }
        })
      }
    })
  }
  return flagArr
}
export async function getAttributeB (attrCodes, targetType) { // 文本类型的属性方法
  let flagArr = []
  let attrCodeArr = attrCodes.split(',')
  let json = {}
  await getTAttributeObjRelListCrm3({
    targetType: targetType || 2, // '目标对象类型(1.用户，2.租户，3.客户)',
    tenantCode: localStorage.getItem('createTenantCode'),
    useTenantCode: localStorage.getItem('tenantCode'),
    targetCode: targetType == 1 ? localStorage.getItem('userCode') : localStorage.getItem('tenantCode'),
    attributeFlags: attrCodes
  }).then(res => {
    if (res) {
      let arr = JSON.parse(res)
      arr.forEach(item => {
        if (item) {
          json[item.attributeFlag] = item
        }
      })
      attrCodeArr.forEach(item => {
        if (json[item]) {
          flagArr.push(json[item].attributeValue)
        } else {
          flagArr.push('')
        }
      })
    }
  }).catch(error => {
    this.$message({
      showClose: true,
      message: error.message,
      type: 'error',
      onClose () {
      }
    })
  })
  return flagArr
}
